interface IQueryParam {
  key: string
  value: string
}

interface IParseAccountsQueryParamsProps {
  pathname: string
  queryParams: IQueryParam[] | null
  subdomain?: string
}

export function parseAccountsQueryParams ({
  pathname,
  queryParams,
  subdomain
}: IParseAccountsQueryParamsProps) {
  if (!pathname && ((queryParams == null) || queryParams.length === 0)) return ''

  // si tengo algun basename en la url, no lo tengo en cuenta
  if (
    typeof process.env.BASENAME !== 'undefined' &&
    process.env.BASENAME !== ''
  ) {
    pathname = pathname.replace(process.env.BASENAME, '')
  }
  if (pathname[0] === '/') pathname = pathname.slice(1)

  const params = []
  if (subdomain) {
    params.push(`s=${subdomain}`)
  }
  if (pathname) {
    const newParam = `dl=aura-feature_${pathname ?? ''}`
    params.push((queryParams != null) ? `${newParam}_` : newParam)
  }
  if ((queryParams != null) && Array.isArray(queryParams) && queryParams.length > 0) {
    params.push(`aura-params_${queryParams.map(param => `aura-key=${param.key}aura-value=${param.value}`).join('___')}`) // &${ getRouteParams().map( param => `${ param.key }=${ param.value }` ).join( '&' ) } creo que esto es para parametros GTM
  }
  return (params.length > 0) ? (`?${params.join('&')}`) : ''
}
